export const parseCookie = (str: string) =>
  str
    ? str
        .split(';')
        .map((v) => v.trim().split('='))
        .reduce((acc: { [index: string]: string }, v: string[]) => {
          acc[decodeURIComponent(v[0])] = decodeURIComponent(v[1]);
          return acc;
        }, {})
    : {};

export const setCookieValue = async (key: string, value: string) => {
  const cookieData = parseCookie(document.cookie);
  cookieData[key] = value;

  await cleanCookie();
  document.cookie = `${key}=${value}`;
};

const cleanCookie = async () => {
  const values = parseCookie(document.cookie);

  const cookieValues = document.cookie.split(';');

  const cleanValues = cookieValues.reduce(
    (acc: { [index: string]: string }, v) => {
      const [key, value] = v.split('=');

      if (!acc[key]) {
        acc[key] = value;
      }

      return acc;
    },
    {},
  );
  // remove all keys from the cookie
  await Promise.resolve(() => {
    Object.keys(values).map((key) => {
      // console.log('clean', key);
      document.cookie = `${key}=; expires=Thu, 01-Jan-70 00:00:01 GMT;`;
    });
  });

  // reset all the keys
  await Promise.resolve(() => {
    Object.keys(cleanValues).map((key) => {
      // console.log('set', key, cleanValues[key]);
      document.cookie = `${key}=${cleanValues[key]}`;
    });
  });
};
